export enum WishlistIconName {
  Wishlist = 'Wishlist',
  WishlistEmpty = 'WishlistEmpty',
}

export const wishlistIconAssets: {[key in WishlistIconName]: string} = {
  [WishlistIconName.Wishlist]: require('./ic-wishlist.svg'),
  [WishlistIconName.WishlistEmpty]: require('./ic-wishlist-empty.svg'),
};
